import { Form, Input, message, Select, Skeleton, Steps } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { updateTeacher } from "api/services/auth/auth.services";
import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateUser } from "store/auth/authSlice";
import * as TEACHER_SERVICES from "../../api/services/teacher/teacher.services";
import * as TOPICS_SERVICES from "../../api/services/topics/topics.services";

//!COMPONENTS

//!IMAGES

//!STYLES
import { CKEditor } from "ckeditor4-react";
import {
  educSystem,
  HandlerInputError,
  Language,
  removeDuplicates,
  StatusCode,
} from "common/enums";
import AppButton from "components/libs/button";
import H2 from "components/libs/subtitle";
import s from "./assets/stepTwo.module.css";

const { Step } = Steps;
const { Option } = Select;

type Props = {
  // setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  // firstStepData: any;
  // setCurrent: React.Dispatch<React.SetStateAction<number>>;
  formRef?: any;
};

const UpdateProfileStepTwo: FC<Props> = ({ formRef }) => {
  //!HOOKS
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  ///const levels = useSelector((state) => state.levels);

  //!STATES
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [userNivMat, setUserNivMat] = useState<any>([]);
  const [tempTopic, setTempTopic] = useState<any>([]);
  const refAddCreneau = useRef<any>();
  const refAddMatiere = useRef<any>();

  const [levels, setLevels] = useState<any>([]);
  const [loadingLevels, setLoadingLevels] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<{ [key: string]: any[] }>({});

  const [courses, setCourses] = useState<any>([]);

  const [prices, setPrices] = useState<any>([]);

  const [coursesByGroup, setCoursesByGroup] = useState<any>({});
  const [loadingCoursesGroup, setLoadingCoursesGroup] = useState<any>({});

  const [selectedLevelCourse, setSelectedLevelCourse] = useState<{ levelGroup: string; matiere: string[] }[]>([]);

  //!FUNCTIONS
  const UpdateUser = async (values: any) => {

    const patchUpdate = {
      educSystem: [...values.educSystem],
      langues: [...values.langues],
      career: values.career,
    };

    if (selectedLevelCourse?.length !== prices?.length) {
      message.warning("Merci de rensigner les tarif pour chaque niveau.");
      return;
    }

    try {
      setisLoading(true);

      const respons = await TEACHER_SERVICES.addLevelsCourses(user?._id, selectedData, selectedLevelCourse, prices);
      if (respons?.statusCode === StatusCode.CREATED) {
        const response = await updateTeacher(user?._id, patchUpdate);
        if (response?.statusCode === StatusCode.OK) {
          const finalUser = await AUTH_SERVICES.getUserByUid(user.uid);
          if (finalUser?.data) {
            dispatch(updateUser(finalUser.data));
          }
          message.success("Modifié avec succès");
        }
      }
      else {
        message.warning("une erreur est survenue");
      }
    } catch (error) {
    } finally {
      setisLoading(false);
    }
  };

  const handleGroupClick = (group: string) => {
    setSelectedData((prev: any) => {
      // Toggle selection: If group is already selected, remove it; otherwise, add it
      if (prev[group]) {
        const { [group]: _, ...rest } = prev; // Remove the selected group
        return rest;
      }
      return { ...prev, [group]: levels[group] };
    });
  };

  const handleLevelCourseClick = (group: string, course: string) => {
    setSelectedLevelCourse((prev) => {
      const groupIndex = prev.findIndex(item => item.levelGroup === group);

      // If the group already exists in the state
      if (groupIndex !== -1) {
        const groupData = prev[groupIndex];
        const isAlreadySelected = groupData.matiere.includes(course);

        const updatedMatiere = isAlreadySelected
          ? groupData.matiere.filter(id => id !== course) // remove course
          : [...groupData.matiere, course]; // add course

        const updatedGroup = { ...groupData, matiere: updatedMatiere };
        const newState = [...prev];
        newState[groupIndex] = updatedGroup;
        return newState;
      } else {
        // Group not yet added
        return [...prev, { levelGroup: group, matiere: [course] }];
      }
    });
  };

  const handlePrices = (level: string, value: string | number) => {
    setPrices((prevPrices: any[]) => {
      const updatedPrices = [...prevPrices];
      const existingIndex = updatedPrices.findIndex((p) => p.level === level);
      if (existingIndex !== -1) {
        // Update the existing price
        updatedPrices[existingIndex].price = value;
      } else {
        // Add a new entry
        updatedPrices.push({ levelGroup: level, price: value });
      }
      return updatedPrices;
    });
  };

  const fetchLevels = async () => {
    try {
      setLoadingLevels(true);
      const response = await TOPICS_SERVICES.fetchLevels();
      if (response) {
        const structuredData = Object.keys(response.data).reduce((acc, key) => {
          acc[key] = response.data[key] ?? [];
          return acc;
        }, {} as Record<string, any[]>);

        setLevels(structuredData);
      }
    } catch (error) { }
    finally {
      setLoadingLevels(false);
    }
  }

  const fetchLevelCourses = async (group: any) => {
    try {
      setLoadingCoursesGroup((prev: any) => ({ ...prev, [group]: true }));
      const response = await TOPICS_SERVICES.fetchLevelCourses(group);
      if (response) {
        setCoursesByGroup((prev: any) => ({ ...prev, [group]: response.data }));
      }
    } catch (error) {
      console.error("Error fetching courses for group", group, error);
    } finally {
      setLoadingCoursesGroup((prev: any) => ({ ...prev, [group]: false }));
    }
  };

  useEffect(() => {
    fetchLevels();
  }, [user]);

  useEffect(() => {
    if (user?.groupLevels.length !== 0) {
      const uniqueData = removeDuplicates(user?.groupLevels);
      uniqueData.forEach((groupData: any) => {
        handleGroupClick(groupData?.levelGroup);
      });
    }
  }, [user, levels]);

  useEffect(() => {
    if (user?.matieres?.length && levels && courses) {
      user.matieres.forEach((groupEntry: any) => {
        const group = groupEntry.levelGroup;
        groupEntry.matiere.forEach((courseTitle: any) => {
          handleLevelCourseClick(group, courseTitle);
        });
      });
      setDataLoaded(true);
    }
  }, [levels, courses]);

  useEffect(() => {
    if (dataLoaded && user?.groupLevels.length !== 0 && user?.matieres.length !== 0) {
      user?.groupLevels.forEach((groupData: any) => {
        handlePrices(groupData?.levelGroup, groupData?.price);
      });
    }
  }, [dataLoaded]);

  useEffect(() => {
    if (dataLoaded && user?.groupLevels.length !== 0 && user?.matieres.length !== 0 && prices) {
      prices.forEach((data: any) => {
        form.setFieldsValue({
          [`price${data.levelGroup}`]: data.price || 0,
        });
      });
    }
  }, [user, dataLoaded, prices, form, selectedLevelCourse]);

  useEffect(() => {
    if (Object.keys(selectedData).length === 0) {
      setCourses([]);
    }
    else {
      Object.keys(selectedData).forEach(group => {
        fetchLevelCourses(group);
      });
    }
  }, [selectedData]);

  return (
    <>
      <div className={s.levelsBox}>
        <span>Je donne des cours en : </span>
        {loadingLevels ? <Skeleton></Skeleton> : <div className={s.levelsButtons}>
          {Object.keys(levels).map((group) => (
            <button
              key={group}
              onClick={() => handleGroupClick(group)}
              className={`${selectedData[group] ? s.levelButtonActive : s.levelButton}`}
            >
              {group}
            </button>
          ))}
        </div>}
      </div>

      {loadingLevels ? <Skeleton></Skeleton> : Object.keys(selectedData).map((group: any) => (
        <div className={s.levelsBox} key={group}>
          <span>Pour le {group} j’enseigne : </span>
          {loadingCoursesGroup[group] ? (
            <Skeleton active />
          ) : (
            <div className={s.topicButtons}>
              {coursesByGroup[group]?.map((course: any) => {
                const groupCourses = selectedLevelCourse.find(item => item.levelGroup === group)?.matiere || [];
                const isSelected = groupCourses.includes(course.title);

                return (
                  <button
                    key={course._id}
                    onClick={() => handleLevelCourseClick(group, course.title)}
                    className={isSelected ? s.topicButtonActive : s.topicButton}
                  >
                    {course.title}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      ))}

      {Object.keys(selectedData).length !== 0 && selectedLevelCourse.length !== 0 && <div className={s.pricesBox}>
        <span>Mes tarifs horaires sont : </span>
        <div className={s.priceBox}>
          {Object.keys(selectedData).map((level) => {
            return (<div className={s.price}>
              <div className={s.priceLevel}>{level}</div>
              <Form form={form}>
                <Form.Item
                  name={`price${level}`}
                  rules={[
                    { required: true, message: "Ce champ est obligatoire." },
                  ]}
                  style={{ marginLeft: "20px" }}
                >
                  <Input
                    className={s.field}
                    placeholder="30"
                    suffix={"€/Heure"}
                    type="number"
                    min={0}
                    onBlur={(e) => handlePrices(level, e.target.value)}
                  />
                </Form.Item>
              </Form>
            </div>);
          })}
        </div>
      </div>}

      <Form onFinish={UpdateUser} initialValues={{ nivMat: user?.nivMat }} ref={formRef}>
        <div className={s.full__content}>
          <div className={s.__content} style={{ gap: "2em" }}>
            <div className={s.levelBox}>
              <div className={s.inputBox}>
                <div>
                  <H2>Système d'éducation :</H2>
                </div>
                <div style={{ marginLeft: "10px" }}>
                  <div className={s.field}>
                    <Form.Item
                      style={{ margin: 0, padding: 0 }}
                      name={"educSystem"}
                      initialValue={user?.educSystem}
                    >
                      <Select
                        className={s.select}
                        placeholder="Système d'éducation"
                        mode="multiple"
                        style={{ width: "100%" }}
                        bordered={false}
                        allowClear
                      >
                        <Option value={educSystem.MOROCCO}>
                          Système Marocain
                        </Option>
                        <Option value={educSystem.FRENCH}>
                          Système Français
                        </Option>
                        <Option value={educSystem.BELGE}>Système Belge</Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
            <div className={s.languageBox}>
              <div className={s.inputBox}>
                <div>
                  <H2>Je parle :</H2>
                </div>
                <div style={{ marginLeft: "10px" }}>
                  <div className={s.field}>
                    <Form.Item
                      style={{ margin: 0, padding: 0 }}
                      name={"langues"}
                      initialValue={user?.langues}
                    >
                      <Select
                        className={s.select}
                        placeholder="Langues"
                        mode="multiple"
                        style={{ width: "100%" }}
                        bordered={false}
                        allowClear
                      >
                        <Option value={Language.ENGLISH}>Anglais</Option>
                        <Option value={Language.FRENCH}>Français</Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={s.full__content}>
          <H2 className={s.title}>À propos de moi et mon cours : </H2>

          <div className={s.text__area}>
            {/* <Form.Item style={{ margin: 0, padding: 0 }} name="career">
            <Input.TextArea bordered={false} rows={12} />
          </Form.Item> */}
            <Form.Item
              initialValue={user?.career}
              name={"career"}
              valuePropName="data"
              getValueFromEvent={(event) => {
                const data = event.editor.getData();
                return data;
              }}
              rules={[
                {
                  required: true,
                  message: HandlerInputError.content,
                },
              ]}
            >
              <CKEditor
                initData={user?.career}
                config={{
                  language: 'fr',
                }}
                style={{
                  border: "none",
                }}
              />
            </Form.Item>
          </div>
        </div>

        <div style={{ display: "flex", marginBottom: "4.5em", alignItems: "center", justifyContent: "center" }}>
          <Form.Item style={{ margin: 0, padding: 0 }}>
            <AppButton loading={isLoading} htmlTypeSubmit={true}>
              Mettre à jour
            </AppButton>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

export default UpdateProfileStepTwo;
